import { Typography } from "@mui/material";

function Heading({
    fontSize = 24, // fontsize in pixels
    color = "#455468",
    className,
    component,
    style,
    children,
}) {
    return (
        <Typography
            component={component}
            className={className}
            sx={{
                fontFamily: "Public Sans",
                fontSize,
                fontWeight: 600,
                color,
                ...style,
            }}
        >
            {children}
        </Typography>
    );
}

export default Heading;
